export default "__VITE_ASSET__C46kY_dn__"